import { LexicalRichText, LexicalRichTextContent } from '@/app/_components/RichText/lexical.jsx'
import { cmsGraphql, FragmentType, getFragmentData } from '../../lib/cms/index.js'
import { Gutter } from '@/app/_components/Gutter/index.jsx'
import { ArticleTableOfContents } from '@/app/_components/ArticleTableOfContents/index.jsx'
import { cn } from '@navinc/base-react-components'
import { ResultOf } from '@graphql-typed-document-node/core'
import { isBlockKind } from '../is-block-kind.js'

export const richTextBlockTypename = 'CmsRichTextBlock'
export const richTextBlockType = 'richText'

export const richTextBlockFragment = cmsGraphql(/* GraphQL */ `
  fragment richTextBlockFragment on CmsRichTextBlock {
    richTextContent
    tableOfContents {
      idAttribute
      text
    }
    richTextSettings {
      enableTOC
    }
  }
`)

export const isRichTextBlock = (block: unknown): block is ResultOf<typeof richTextBlockFragment> => {
  return isBlockKind(block, richTextBlockTypename, richTextBlockType)
}

export type richTextBlockProps = {
  data: FragmentType<typeof richTextBlockFragment>
}

export const RichTextBlock = ({ data }: richTextBlockProps) => {
  const { richTextContent, tableOfContents, richTextSettings } = getFragmentData(richTextBlockFragment, data)
  return (
    <div className="mt-300 md:mt-[72px]">
      <Gutter className="max-w-[1472px]">
        <div className="Wrapper grid w-full grid-cols-12 gap-300 px-200 desktop:gap-800">
          {richTextSettings?.enableTOC ? (
            <aside
              className="accordion top-[70px] col-span-12 overflow-auto bg-surface md:sticky md:col-span-4"
              style={{ maxHeight: 'calc(100vh - 60px)' }}
            >
              {tableOfContents && tableOfContents.length ? <ArticleTableOfContents data={tableOfContents} /> : null}
            </aside>
          ) : null}

          <section className={cn('Content col-span-12 flex flex-col', richTextSettings?.enableTOC && 'md:col-span-8')}>
            <LexicalRichText content={richTextContent as LexicalRichTextContent} />
          </section>
        </div>
      </Gutter>
    </div>
  )
}
